import gql from 'graphql-tag'

export const CreateLoanApplication = gql`
    mutation CreateLoan($input: CreateLoanApplicationInput!) {
        createLoanApplication(input: $input) {
            createdOn
            id
            owner
            state
            updatedOn
            userProfileId
        }
    }
`
export const UpdateLoanApplication = gql`
    mutation Update($loan_application: InputLoanApplicationFromNode!) {
        updateLoanApplicationInNode(loan_application: $loan_application) {
            data {
                loan_application_id
                status
            }
        }
    }
`

export const GetPreQualificationData = gql`
    query getPreQualificationData($userId: String) {
        getPreQualificationData(userId: $userId) {
            totalNetWorth
            totalDebt
            totalCryptoWorth
            monthlyIncome
            freeCashFlow
            debtToIncomeRatio
            preQualified
            totalAssets
        }
    }
`
